import {
    SEND_EMAIL_SAGA
} from './types_saga';

export const sendEmailSaga = data => ({ type: SEND_EMAIL_SAGA, data });